import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps, Typography, TypographyProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export const ProductCustomizationPanel = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productCustomizationPanel, style]} />
);

export const GroupsCustomizationModifiersContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.groupsCustomizationModifiersContainer, style]} />
);

export const ModifiersCustomizationContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.modifiersCustomizationContainer, style]} />
);

export const DrinksTabLink = Pressable.withConfig<{ active: boolean }>(({ active }) => ({
  flexGrow: 1,
  isUnderlined: false,
  margin: 0,
  fontFamily: 'body',
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: active ? 2 : 0,
  borderBottomColor: active ? getDesignToken('color-tertiary') : 'transparent',
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',

  _focus: {
    borderBottomColor: {
      base: active ? getDesignToken('color-tertiary') : 'transparent',
      md: active ? primitive.$bbqBrown : 'transparent',
    },
  },

  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const DrinksTabLinkText = ({
  active,
  style,
  ...props
}: TypographyProps & { active?: boolean }) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Typography
      color={getDesignToken('color-tertiary')}
      fontFamily={active ? 'heading' : 'body'}
      mt="$0"
      fontSize={isDesktop ? 'sm' : undefined}
      lineHeight={isDesktop ? 'md' : undefined}
      style={[{ textTransform: 'capitalize' }, style]}
      {...props}
    />
  );
};

export const DrinksTabsWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.drinksTabsWrapper, style]} />
);

export const DrinksTabsContent = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[styles.drinksTabsContent, isDesktop && styles.drinksTabsContentDesktop, style]}
    />
  );
};

const styles = StyleSheet.create({
  drinksTabsContent: {
    marginTop: 24,
  },
  drinksTabsContentDesktop: {
    marginTop: 32,
  },
  drinksTabsWrapper: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
    height: 56,
    marginVertical: spacing.$0_5,
    paddingHorizontal: 0,
    paddingTop: spacing.$2,
    position: 'relative',
    width: '100%',
  },
  groupsCustomizationModifiersContainer: {
    margin: 0,
    padding: 0,
    width: '100%',
  },
  modifiersCustomizationContainer: {
    backgroundColor: primitive.$blackOpacity4,
    borderRadius: primitive.$borderRadius,
    marginVertical: spacing.$4,
    paddingHorizontal: spacing.$2,
    paddingVertical: spacing.$4,
    width: '100%',
  },
  productCustomizationPanel: {
    alignSelf: 'center',
    height: '100%',
    width: '100%',
  },
});
